import PropTypes from "prop-types";

import UniversalCommunicationLogDialog from "../../dialog/UniversalCommunicationLogDialog";

import { useTranslation } from "react-i18next";

const MeterCommunicationLogsForm = (props) => {
  const { t } = useTranslation();

  return (
    <div style={{ marginTop: 7, marginBottom: -20 }}>
      <UniversalCommunicationLogDialog
        showDialogAsForm
        itemId={props.equipmentId}
        itemType={"equipment"}
        showExtendedAddEnclosureDialog={false}
        messageWindowHeight={400}
        inputMessageFormGridJustifyContent={"space-around"}
        inputMessageFormEnterButtonGridSmGrid={2}
        showAttachmentsButton={false}
        preventDownloadEnclosure={true}
        showMessageType={false}
        inputMessageFormMessageContentGridSmGrid={10}
        defaultChosenMessageFilterGroup={["log", "internal"]}
        defaultMessageSearchParams={{ exclude_externals: true }}
        topCommunicationDiaryBoxJustifyContent={"flex-end"}
        readOnly={props.readOnly}
      />
    </div>
  );
};

MeterCommunicationLogsForm.propTypes = {
  messages: PropTypes.array,
  equipmentId: PropTypes.string,
  readOnly: PropTypes.bool,
};

MeterCommunicationLogsForm.defaultProps = {};

export default MeterCommunicationLogsForm;
